import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { enable_force_refresh } from '../../state/force-refresh';
import { uil_can_redo, uil_redo } from '../../ui_logic';
import redo_svg from '../../../assets/img/SVG_icons/Left/main_control/redo.svg';
import { img } from '@phi/components';
import RedoTooltip from './RedoTooltip';

export const RedoIcon = redo_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded || this.state.tut_stage < 1;
        },

        alt() {
            return 'Redo';
        },

        disabled() {
            if (this.coming_soon)
                return true;
            else {
                enable_force_refresh();
                return !uil_can_redo();
            }
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uil_redo();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            id: 'redo-button',
            wrapperId: 'redo-button-wrapper',
            tippy: 'right',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(redo_svg, this.alt),
            tooltip: RedoTooltip,
        });
    },
});
